export const ApiEndpoints = {
  autor: {
    authorList: "api/authors",
    authorCreate: "api/author/store",
    authorEdit: "api/author/edit/",
    authorUpdate: "api/author/update",
    authorDelete: "api/author/delete",
  },
  tags: {
    tagList: "api/tags",
    tagCreate: "api/tag/store",
    tagEdit: "api/tag/edit/",
    tagUpdate: "api/tag/update",
    tagDelete: "api/tag/delete",
  },
  adminBlogs: {
    blogList: "api/aiblogs",
    blogCreate: "api/aiblog/store",
    blogEdit: "api/aiblog/edit/",
    blogUpdate: "api/aiblog/update/",
    blogDelete: "api/aiblog/delete",
  },
  news: {
    newsList: "api/news",
    newsCreate: "api/news/store",
    newsEdit: "api/news/edit/",
    newsUpdate: "api/news/update/",
    newsDelete: "api/news/delete",
  },
  newsCategory: {
    categoryList: "api/news-categories",
    categoryCreate: "api/news-category/store",
    categoryEdit: "api/news-category/edit/",
    categoryUpdate: "api/news-category/update",
    categoryDelete: "api/news-category/delete",
  },
  comparison: {
    List: "api/comparisons",
    Create: "api/comparison/store",
    Edit: "api/comparison/edit/",
    Update: "api/comparison/update/",
    Delete: "api/comparison/delete",
  },
  category: {
    categoryList: "api/blog-categories",
    categoryCreate: "api/blog-category/store",
    categoryEdit: "api/blog-category/edit/",
    categoryUpdate: "api/blog-category/update",
    categoryDelete: "api/blog-category/delete",
  },
  tmsIntegrationCategory: {
    categoryList: "api/tms-integration-categories",
    categoryCreate: "api/tms-integration-category/store",
    categoryEdit: "api/tms-integration-category/edit/",
    categoryUpdate: "api/tms-integration-category/update",
    categoryDelete: "api/tms-integration-category/delete",
  },
  tmsIntegration: {
    integrationList: "api/tms-integrations",
    integrationCreate: "api/tms-integration/store",
    integrationEdit: "api/tms-integration/edit/",
    integrationUpdate: "api/tms-integration/update/",
    integrationDelete: "api/tms-integration/delete",
  },
  industry: {
    List: "api/industries",
    Create: "api/industry/store",
    Edit: "api/industry/edit/",
    Update: "api/industry/update",
    Delete: "api/industry/delete",
  },
  case: {
    List: "api/casestudys",
    Create: "api/casestudys/store",
    Edit: "api/casestudy/edit/",
    Update: "api/casestudy/update/",
    Delete: "api/casestudy/delete",
  },
  seo: {
    seoList: "api/seo",
    seoCreate: "api/seo/store",
    seoEdit: "api/seo/edit/",
    seoUpdate: "api/seo/update",
    seoDelete: "api/seo/delete",
    seoByUrl: 'api/seo-by-url'
  },
  schemaManagement: {
    view: "api/schema-management",
    update: "api/schema-management/update",
  },
  globalSeo: {
    view: "api/global-seo",
    update: "api/global-seo/update",
  },
  sitemap: {
    view: "api/sitemap",
    update: "api/sitemap/update",
  },
  llms: {
    view: "api/llms",
    update: "api/llms/update",
  },
  robots: {
    view: "api/robots-txt",
    update: "api/robots-txt/update",
  },
  contact: {
    contactCreate: "api/contact/store",
    contactList: "api/contact/view",
  },
  homeform: {
    homeformCreate: "api/homeform/store",
    homeformList: "api/homeform/view",
  },
  newsletter: {
    newsletterCreate: "api/newsletter/store",
    newsletterList: "api/newsletter/view",
  },

  emailManagement: {
    List: "api/dynamic-emails",
    Create: "api/dynamic-email/store",
    Edit: "api/dynamic-email/edit/",
    Update: "api/dynamic-email/update",
    Delete: "api/dynamic-email/delete",
  },

  rbac: {
    myPermissions: "api/rbac/my-permissions",
    userList: "api/rbac/users",
    userCreate: "api/rbac/user/store",
    userEdit: "api/rbac/user/edit/",
    userUpdate: "api/rbac/user/update/",
    userDelete: "api/rbac/user/delete",
    roleList: "api/rbac/roles",
    roleCreate: "api/rbac/role/store",
    roleEdit: "api/rbac/role/edit/",
    roleUpdate: "api/rbac/role/update/",
    roleDelete: "api/rbac/role/delete",
    permissionList: "api/rbac/permissions",
    permissionCreate: "api/rbac/permission/store",
    permissionEdit: "api/rbac/permission/edit/",
    permissionUpdate: "api/rbac/permission/update/",
    permissionDelete: "api/rbac/permission/delete",
  },


  dashboard: {
    dashboardcount: "api/dashboard-counts",
    monthlycount: "api/dashboard-counts/",
  },

  clientLogo: {
    List: "api/logos",
    Create: "api/logo/store",
    Edit: "api/logo/edit/",
    Update: "api/logo/update",
    Delete: "api/logo/delete",
  },

  stats: {
    create: "api/stat/store",
    edit: "api/stat/edit",
    update: "api/stat/update",
  },



  subCategory: {
    subCategoryList: "api/dynamic-page-sub-categories",
    subCategoryCreate: "api/dynamic-page-sub-category/store",
    subCategoryEdit: "api/dynamic-page-sub-category/edit/",
    subCategoryUpdate: "api/dynamic-page-sub-category/update",
    subCategoryDelete: "api/dynamic-page-sub-category/delete",
  },

  Dynamiccategory: {
    categoryList: "api/dynamic-page-categories",
    categoryCreate: "api/dynamic-page-category/store",
    categoryEdit: "api/dynamic-page-category/edit/",
    categoryUpdate: "api/dynamic-page-category/update",
    categoryDelete: "api/dynamic-page-category/delete",
  },



  locService: {
    locServiceList: "api/dynamic-pages",
    locServiceCreate: "api/dynamic-page/store",
    locServiceEdit: "api/dynamic-page/edit/",
    locServiceUpdate: "api/dynamic-page/update",
    locServiceDelete: "api/dynamic-page/delete",
  },


  calculator: {
    calculatorList: "api/roi-calculator",
    calculatorCreate: "api/roi-calculator/store",
    calculatorEdit: "api/roi-calculator/edit/",
    calculatorUpdate: "api/roi-calculator/update",
    calculatorDelete: "api/roi-calculator/delete",
  },


  price: {
    priceList: "api/plans",
    priceCreate: "api/plan/store",
    priceUpdate: "api/plan/update",
  },


  featureCategory: {
    featureList: "api/feature-categories",
    featureCreate: "api/feature-category/store",
    featureEdit: "api/feature-category/edit/",
    featureUpdate: "api/feature-category/update",
    featureDelete: "api/feature-category/delete",
  },


  featureService: {
    featureServiceList: "api/features",
    featureServiceCreate: "api/feature/store",
    featureServiceEdit: "api/feature/edit/",
    featureServiceUpdate: "api/feature/update/",
    featureServiceDelete: "api/feature/delete",
  },

  faq: {
    faqList: "api/faqs",
    faqCreate: "api/faq/store",
    faqEdit: "api/faq/edit/",
    faqUpdate: "api/faq/update",
    faqDelete: "api/faq/delete",
    faqByUrl: "api/faq-by-url",
  },


  dynamic: {
    dynamicList: "api/service/view",
    dynamicCreate: "api/service/store",
    dynamicEdit: "api/service/edit/",
    dynamicUpdate: "api/service/update/",
    dynamicDelete: "api/service/delete",
  },


};
